import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-master',
  imports: [NgFor, RouterLink, NgClass, SelectInputComponent, NgIf, HeaderComponent, SearchInputComponent],
  templateUrl: './master.component.html',
  styleUrl: './master.component.css'
})
export class MasterComponent implements OnInit, OnDestroy {
  master_groups: any[] = [];
  private route_sub!: Subscription;

  constructor(private router: Router,public route:ActivatedRoute) {}

  private prepare_master_groups(path: string) {
    if (path == '/master') {
      this.master_groups = [
        {
          title: 'Locations',
          icon: 'bx-location',
          links: [
            { label: 'Country', link: '/country/list' },
            { label: 'State', link: '/state/list' },
            // { label: 'Division', link: '/division/list' },
            { label: 'District', link: '/district/list' },
            // { label: 'Taluka', link: '/taluka/list' },
            { label: 'City', link: '/city/list' }
          ]
        },
        {
          title: 'University & College',
          icon: 'bx-school',
          links: [
            { label: 'University', link: '/university/list' },
            { label: 'College', link: '/college/list' }
          ]
        },
        {
          title: 'Course',
          icon: 'bx-book',
          links: [
            { label: 'Level', link: '/level/list' },
            { label: 'Stream', link: '/stream/list' },
            { label: 'Program', link: '/program/list' },
            // { label: 'Course', link: '/course/list' },
            { label: 'Subject', link: '/subject/list' }
          ]
        },
        // {
        //   title: 'Evaluation',
        //   icon: 'bx-book',
        //   links: [
        //     { label: 'Academic year', link: '/academic-year/list' },
        //     { label: 'Exam', link: '/exam/list' },
        //     { label: 'Assessment', link: '/assessment/list' }
        //   ]
        // },
        {
          title: 'User Management',
          icon: 'bx-group',
          links: [
            { label: 'Roles', link: '/role/list' },
            { label: 'Module', link: '/module/list' },
            { label: 'Sub Module', link: '/sub-module/list' },
            { label: 'Permissions', link: '/permission/list' },
            { label: 'Role Permission Mapping', link: '/role-permission-mapping/list' },
            { label: 'Users', link: '/user/list',queryParams: { user_type: 'staff' }},
            { label: 'Student', link: '/user/list',queryParams: { user_type: 'student' } }
          ]
        }
      ];
      return;
    }else if(path == '/evaluation-master'){
      this.master_groups =[
        {
          title: 'Evaluation Management',
          icon: 'bx-book',
          links: [
            { label: 'Academic year', link: '/academic-year/list' },
            { label: 'Exam', link: '/exam/list' },
            { label: 'Assessment', link: '/assessment/list' }
          ]
        },
      ]
      return;
    }else if(path == '/script-master'){
      this.master_groups =[
        {
          title: 'Script Management',
          icon: 'bx-file',
          links: [
            { label: 'Scripts', link: '/add-script/list' },
            { label: 'Barcode Mapping', link: '/barcode-mapping/list' },
            // { label: 'Student Mapping', link: '/add-script/list' },
            // { label: 'View Stats', link: '/add-script/list' },
          ]
        },
      ]
      return;
    }
  }

  ngOnInit() {
     this.route.queryParams.subscribe(params => {
    const userType = params['user_type'];
    console.log(userType);
  });
      // if (event instanceof NavigationEnd) {
        console.log(window.location.pathname,'Helloooooo');
        this.prepare_master_groups(window.location.pathname);
        
      // }
    
  }

  ngOnDestroy() {
    if (this.route_sub) {
      this.route_sub.unsubscribe();
    }
  }
}
